/**
 * Litres the tank actually reports, or null when the litre reading is not one.
 *
 * Teltonika sends AVL 84 (fuel level, litres) as 0 when the vehicle's bus does not
 * carry that parameter. Many trucks give only a percentage (AVL 89), so the record
 * reads "45 %, 0 L": two readings of the same tank that cannot both be true. The
 * percentage is the real one. Treating that 0 as "no litre reading" lets the caller
 * fall back to percent × tank capacity instead of drawing an empty tank.
 */
export function measuredFuelLitres(litres: number | null, percent: number | null): number | null {
  if (litres === null) return null
  if (litres === 0 && percent !== null && percent > 0) return null
  return litres
}

/** Percent of a tank of the given size, in litres — null when either is unknown. */
export function litresFromPercent(percent: number | null, capacityL: number | null): number | null {
  if (percent === null || capacityL === null || !(capacityL > 0)) return null
  return (percent / 100) * capacityL
}

/**
 * The percentage the gauge actually reports, or null when it is not one: the mirror of
 * `measuredFuelLitres`. Some cars (the Renault Express on CAN program 11976) send
 * AVL 89 = 0 % beside a real litre reading, and "0 %" next to "42 L" is a contradiction
 * in which the litres are the true half.
 */
export function reportedFuelPercent(percent: number | null, litres: number | null): number | null {
  if (percent === null) return null
  if (percent === 0 && litres !== null && litres > 0) return null
  return percent
}
